// Tipos de días para los plazos
export const DEADLINE_TYPES = {
    NORMAL: { value: 1, label: 'DEADLINE_TYPE_NORMAL' },        //? Días de corrido
    BUSSINESS: { value: 2, label: 'DEADLINE_TYPE_BUSSINESS' },  //? Días de hábiles
    OTHER: { value: 3, label: 'DEADLINE_TYPE_OTHER' },          //? Otros
};
// Tipos de días para dropdown
export const DEADLINE_TYPES_DROPDOWN = [
    { value: 1, name: 'DEADLINE_TYPE_NORMAL' },         //? Días de corrido
    { value: 2, name: 'DEADLINE_TYPE_BUSSINESS' },      //? Días de hábiles
    { value: 3, name: 'DEADLINE_TYPE_OTHER' },          //? Otros
];

